define('modules/base/models/contract.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function(_, Backbone, BaseModel){
    var ContractModel = BaseModel.extend({
        debugName: 'ContractModel',
        base : 'user/contract',
        useLocalStorage: true,
        onlyUseLocalStorageOnPageLoad: true,
        initialize:function(options){
            //this.on('sync', this.checkIsValid, this);
            BaseModel.prototype.initialize.call(this, options);
        },
        getDaysLeft:function(){
            var today = new Date();
            var endDay = new Date(this.get('endDate'));
            return Math.floor((endDay - today) / (1000 * 60 * 60 * 24)) + 1;
        },
        isExpired:function(){
            return this.get('status') > 2;
        },
        //checking if trial user
        isTrial:function(){
            var planId = this.get('plan').id;
            return planId == 1 || planId == 2;
        },
        notPaid:function(){
            return this.get('paymentSource').status > 3;
        },
        checkIsValid:function(){
            if(this.isExpired() || this.getDaysLeft() < 1 || this.notPaid()){
                return false;
            }
            else {
                return true;
            }
        }
    });
    return ContractModel;
});


